export default __webpack_public_path__ + "static/media/woman-draw-1period.a8e9ef77.svg";